import * as MyTypes from "MyTypes";
import { actionTypes } from "../actions/";


interface ICoordinates {
  lat: number;
  lng: number,
  country:string
}
export const initialState: ICoordinates = {
   lat: 8.95,
   lng: -77.38,
   country: "us"
  };

export const CoordinatorReducer = (state: ICoordinates = initialState, action: MyTypes.RootAction) => {
  switch (action.type) {
    case actionTypes.SAVE_COORDINATES: {
      return {
        ...state,
        lat: action.payload.lat,
        lng: action.payload.lng,
        country: action.payload.country
      };
    }
    default:
      return state;
  }
};
